import React from "react";

function DropProps({ title }) {
  return <div>{title}</div>;
}

export default DropProps;
